export const LedSequenceActionType = {
  SET_PROPERTY_VALUE: 'LED_SEQUENCE.SET_PROPERTY_VALUE',

  GET_LIST_API: 'LED_SEQUENCE.GET_LIST_API',
  GET_LIST_API_SUCCESS: 'LED_SEQUENCE.GET_LIST_API_SUCCESS',
  GET_LIST_API_FAILURE: 'LED_SEQUENCE.GET_LIST_API_FAILURE',

  GET_BY_ID_API: 'LED_SEQUENCE.GET_BY_ID_API',
  GET_BY_ID_API_SUCCESS: 'LED_SEQUENCE.GET_BY_ID_API_SUCCESS',
  GET_BY_ID_API_FAILURE: 'LED_SEQUENCE.GET_BY_ID_API_FAILURE',

  CHANGE_LED_SEQUENCE_INPUT_VALUE: 'LED_SEQUENCE.CHANGE_LED_SEQUENCE_INPUT_VALUE',

  POST_BY_ID_API: 'LED_SEQUENCE.POST_BY_ID_API',
  POST_BY_ID_API_FAILURE: 'LED_SEQUENCE.POST_BY_ID_API_FAILURE',
  POST_BY_ID_API_SUCCESS: 'LED_SEQUENCE.POST_BY_ID_API_SUCCESS',

  PUT_BY_ID_API: 'LED_SEQUENCE.PUT_BY_ID_API',
  PUT_BY_ID_API_FAILURE: 'LED_SEQUENCE.PUT_BY_ID_API_FAILURE',
  PUT_BY_ID_API_SUCCESS: 'LED_SEQUENCE.PUT_BY_ID_API_SUCCESS',

  SET_ORIGINAL_LED_SEQUENCE_VALUE: 'LED_SEQUENCE.SET_ORIGINAL_LED_SEQUENCE_VALUE',

  DELETE_BY_ID_API: 'LED_SEQUENCE.DELETE_BY_ID_API',
  DELETE_BY_ID_API_FAILURE: 'LED_SEQUENCE.DELETE_BY_ID_API_FAILURE',
  DELETE_BY_ID_API_SUCCESS: 'LED_SEQUENCE.DELETE_BY_ID_API_SUCCESS',
}
